module.exports = __webpack_public_path__ + "static/media/header-background.424ac7be.jpg";